export default __webpack_public_path__ + "static/media/download-app.38d16253.png";